const collectTimelineValues = (items = [], getValues = () => [], memo = new Set()) => {
  items.forEach((item) => {
    if (!item) {
      return;
    }

    const values = getValues(item);

    if (Array.isArray(values)) {
      values.forEach((value) => {
        if (value !== undefined && value !== null) {
          memo.add(value);
        }
      });
    } else if (values !== undefined && values !== null) {
      memo.add(values);
    }

    if (item.posts?.length) {
      collectTimelineValues(item.posts, getValues, memo);
    }
  });

  return memo;
};

export {
  collectTimelineValues,
};
